/** @graphql cc **/
import gql from 'graphql-tag';

export const ExternalContentMediaSessionQuery = gql`
	query ExternalContentMediaSessionQuery($shareToken: String!) {
		externalContentMediaSession(shareToken: $shareToken) {
			accessTokens {
				readOnlyToken {
					value
				}
				readWriteToken {
					value
				}
			}
			configuration {
				fileStoreUrl
				clientId
			}
		}
	}
`;
